<template>
  <div>
    <h4 v-if="ts_ready_exported.last_week.length !== 0" class="bp-color">Timesheets Ready For Export (Last Week: week beginning {{ last_week }})</h4>
    <hr v-if="ts_ready_exported.last_week.length !== 0" class="mt-0 mb-2">
    <div v-for="tsre in ts_ready_exported.last_week" class="tsre">
      <b-btn class="tsre_card" @click.prevent="show_ts_ready_export(tsre.client_id, tsre.invoice_type, tsre.sage_ref, tsre.clientname, tsre.ts_setups, tsre.expected, tsre.completed,
   last_week, tsre.gm_solution)"
             :class="[tsre.expected === tsre.completed ? 'complete' : 'not_complete']">
        <div class="tsre_client" style="">{{ tsre.clientname }}</div>
        <div class="tsre_ce">
          <span>E : {{ tsre.expected }}</span><br>
          <span>C : {{ tsre.completed }}</span>
        </div>
      </b-btn>
    </div>
    <h4 v-if="ts_ready_exported.this_week.length !== 0" class="bp-color mt-3">Timesheets Ready For Export (This Week: week beginning {{ this_week }})</h4>
    <hr v-if="ts_ready_exported.this_week.length !== 0" class="mt-0 mb-2">
    <div v-for="tsre in ts_ready_exported.this_week" class="tsre">
      <b-btn class="tsre_card"
             @click.prevent="show_ts_ready_export(tsre.client_id, tsre.invoice_type, tsre.sage_ref,  tsre.clientname, tsre.ts_setups, tsre.expected, tsre.completed, this_week, tsre.gm_solution)"
             :class="[tsre.expected === tsre.completed ? 'complete' : 'not_complete']">
        <div class="tsre_client" style="">{{ tsre.clientname }}</div>
        <div class="tsre_ce">
          <span>E : {{ tsre.expected }}</span><br>
          <span>C : {{ tsre.completed }}</span>
        </div>
      </b-btn>
    </div>
    <h4 v-if="ts_ready_exported.next_week.length !== 0" class="bp-color mt-3">Timesheets Ready For Export (Next Week: week beginning {{ next_week }})</h4>
    <hr v-if="ts_ready_exported.next_week.length !== 0" class="mt-0 mb-2">
    <div v-for="tsre in ts_ready_exported.next_week" class="tsre">
      <b-btn class="tsre_card"
             @click.prevent="show_ts_ready_export(tsre.client_id, tsre.invoice_type, tsre.sage_ref,  tsre.clientname, tsre.ts_setups, tsre.expected, tsre.completed, next_week, tsre.gm_solution)"
             :class="[tsre.expected === tsre.completed ? 'complete' : 'not_complete']">
        <div class="tsre_client" style="">{{ tsre.clientname }}</div>
        <div class="tsre_ce">
          <span>E : {{ tsre.expected }}</span><br>
          <span>C : {{ tsre.completed }}</span>
        </div>
      </b-btn>
    </div>

    <div class="row">
      <div class="col-12">
        <b-card v-if="client_ts === 1" :header="clientname_ts" header-tag="h4" class="mb-4 mt-4">
          <div class="row">
            <div class="col-md-2">
              <div><span class="bcard_ts_words">Expected:</span><span class="bcard_ts_content">{{ client_expected_ts }}</span></div>
              <div><span class="bcard_ts_words">Completed:</span><span class="bcard_ts_content">{{ client_completed_ts }}</span></div>
              <button
                  v-if="$store.state.auth.me.roles.includes('director') || $store.state.auth.me.roles.includes('it') ||
      $store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('accounts')"
                  :disabled="dse === true" class="btn orcaBtn w-100 mt-3 purpleBtn" style="height: auto" v-on:click="exportSageTimesheets(client_id_ts, ts_week)">
                <span v-if="dse === true"><i class="fas fa-spinner fa-spin"></i> Downloading<br>Sage Export</span>
                <span v-else>Download<br>Sage Export</span>
              </button>
              <button class="btn orcaBtn w-100 mt-3 warning" style="height: auto" v-on:click="exportSageInvoice(client_id_ts, ts_week)">
                <span v-if="dsi === true"><i class="fas fa-spinner fa-spin"></i> Downloading<br>Invoice<br>Export</span>
                <span v-else>Download<br>Invoice<br>Export</span>
              </button>
              <button
                  v-if="($store.state.auth.me.roles.includes('director') || $store.state.auth.me.roles.includes('it') ||
      $store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('accounts')) && client_id_tsetups !== 0"
                  :disabled="det === true" class="btn orcaBtn w-100 mt-3 mb-3" style="height: auto" v-on:click="viewTimesheet(client_id_ts, ts_week)">
                <span v-if="det === true"><i class="fas fa-spinner fa-spin"></i> Downloading<br>Excel Timesheet</span>
                <span v-else>Download<br>Excel Timesheet</span>
              </button>

              <button class="btn orcaBtn w-100 mt-3 mb-3 danger" style="height: auto" v-on:click="close">Close</button>

              <div v-if="client_id_tsetups === 0">
                <h5 class="bp-red mt-3 text-center">Excel Imported Timesheet</h5>
              </div>

            </div>
            <div class="col-md-10">
              <ag-grid-vue style="width: 100%; height: 400px;"
                           class="ag-theme-balham"
                           :gridOptions="gridOptions"
                           :columnDefs="columnDefs"
                           :defaultColDef="defaultColDef"
                           :floatingFilter="true"
                           :rowData="rowData"

                           @first-data-rendered="onFirstDataRendered">
              </ag-grid-vue>
            </div>
          </div>
        </b-card>
      </div>
    </div>

  </div>
</template>
<script>
import {AgGridVue} from "ag-grid-vue";
import OverlayLoading from "../../../plugins/datatables/overlay_loading";
import OverlayNoRows from "../../../plugins/datatables/overlay_no_rows";

export default {
  name: 'timesheets_ready_to_export',
  props: ['dt_reload'],
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,

      rowData: null,

      dse: false,
      dsi: false,
      det: false,

      ts_ready_exported: {
        last_week: [],
        this_week: [],
        next_week: [],
      },
      client_ts: 0,
      client_ts_invoice_type: null,
      client_ts_sage_ref: null,
      client_ts_gm_solution: null,
      clientname_ts: "",
      client_id_ts: null,
      client_id_tsetups: null,
      client_expected_ts: null,
      client_completed_ts: null,

      ts_week: null,

      last_week: null,
      this_week: null,
      next_week: null,
      two_weeks: null,
    }
  },
  components: {
    AgGridVue,
    OverlayLoading,
    OverlayNoRows,
    'CurrencyComponent': {
      template: '<span>{{ params.value | currency }}</span>',
    },
    'PercentageComponent': {
      template: '<span>{{ params.value | percentage }}</span>',
    },
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {headerName: 'Sage Ref', field: 'sage_ref'},
      {headerName: 'First Name', field: 'first_name'},
      {headerName: 'Surname', field: 'surname'},
      {headerName: 'Pay Rate', field: 'pay_rate', cellRendererFramework: 'CurrencyComponent'},
      {headerName: 'Total Units', field: 'total_units'},
      {headerName: 'Gross Pay', field: 'gross', cellRendererFramework: 'CurrencyComponent'},
      {headerName: 'Retention Amount', field: 'retention_amount', cellRendererFramework: 'CurrencyComponent'},
      {headerName: 'Release Retention', field: 'release_retention'},
      {headerName: 'Retention Percentage', field: 'retention_percentage', cellRendererFramework: 'PercentageComponent'}
    ];

    this.defaultColDef = {resizable: true, sortable: true, filter: true, suppressMenu: true};

    this.last_week = this.$moment().utc().isoWeekday(-6).format('DD-MM-YYYY').toString();
    this.this_week = this.$moment().utc().isoWeekday('Monday').format('DD-MM-YYYY');
    this.next_week = this.$moment().utc().isoWeekday(+8).format('DD-MM-YYYY');
    this.two_weeks = this.$moment().utc().isoWeekday(+16).format('DD-MM-YYYY');
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;

    axios.get(this.crmApiPath + 'sage/timesheets_in_crm', {
      params: {
        last_week: this.last_week,
        this_week: this.this_week,
        next_week: this.next_week,
        two_weeks: this.two_weeks,
      }
    }).then(res => {
      this.ts_ready_exported.last_week = res.data.c_last_week;
      this.ts_ready_exported.this_week = res.data.c_this_week;
      this.ts_ready_exported.next_week = res.data.c_next_week;
    });
  },
  watch: {
    dt_reload() {
      if (this.dt_reload === 1) {
        // this.handleQueryChange();
        this.client_ts = 0;
        axios.get(this.crmApiPath + 'sage/timesheets_in_crm', {
          params: {
            last_week: this.last_week,
            this_week: this.this_week,
            next_week: this.next_week,
            two_weeks: this.two_weeks,
          }
        }).then(res => {
          this.ts_ready_exported.last_week = res.data.c_last_week;
          this.ts_ready_exported.this_week = res.data.c_this_week;
          this.ts_ready_exported.next_week = res.data.c_next_week;
        });
        this.$bus.$emit('download_timesheets', 2);
      }
    },
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },

    show_ts_ready_export(client_id, invoice_type, sage_ref, clientname, tsetups, expected, completed, week, solution) {
      this.client_ts = 1;
      this.client_ts_invoice_type = invoice_type;
      this.client_ts_sage_ref = sage_ref;
      this.client_ts_gm_solution = solution;
      this.clientname_ts = clientname;
      this.client_id_ts = client_id;
      this.client_id_tsetups = tsetups;
      this.client_expected_ts = expected;
      this.client_completed_ts = completed;
      this.ts_week = week;

      axios.get(this.crmApiPath + 'sage/ready/export/timesheets', {params: {client_id: this.client_id_ts, week: week}}).then(response => {
        this.rowData = response.data
      });
    },

    exportSageTimesheets(client_id, week) {
      this.dse = true;
      axios.get(this.crmApiPath + 'sage/export/timesheets', {
        params: {
          client_id: client_id,
          week: week
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Sage_TS_Export-' + this.clientname_ts + '-' + this.$moment().utc().format('DD-MM-YYYY') + '.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.$bus.$emit('download_timesheets', 1);
        this.dse = false;
      })
    },

    export_invoice(client_id, invoice_type, sage_ref, vat, sites, week, client_name, gm_solution) {
      // console.log({
      //   client_id: client_id,
      //   invoice_type: invoice_type,
      //   sage_ref: sage_ref,
      //   vat: vat,
      //   sites: sites,
      //   week: week,
      //   gm_solution: gm_solution
      // })
      return axios.get(this.crmApiPath + 'sage/export/invoice', {
        params: {
          client_id: client_id,
          invoice_type: invoice_type,
          sage_ref: sage_ref,
          vat: vat,
          sites: sites,
          week: week,
          gm_solution: gm_solution
        }
      }).then(response => {
        if (response.data !== "") {
          this.download_file(response.data, client_name, invoice_type, vat);
        }
      });
    },

    export_additions_invoice(client_id, week, vat, sage_ref, invoice_type, sites, client_name, gm_solution) {
      axios.get(this.crmApiPath + 'sage/export/invoice/additions/get', {
        params: {
          client_id: client_id,
          week: week,
          vat: vat,
          gm_solution: gm_solution
        }
      }).then(res => {
        if (Object.keys(res.data).length > 0) {
          axios.get(this.crmApiPath + 'sage/export/invoice/additions', {
            params: {
              client_id: client_id,
              sage_ref: sage_ref,
              vat: vat,
              week: week,
              invoice_type: invoice_type,
              sites: sites,
              gm_solution: gm_solution
            }
          }).then(response => {
            this.download_file(response.data, client_name, 'additions invoice', vat);
          });
        }
      });
    },

    export_deductions_credit(client_id, week, vat, sage_ref, invoice_type, sites, client_name, gm_solution) {
      axios.get(this.crmApiPath + 'sage/export/invoice/deductions/get', {
        params: {
          client_id: client_id,
          week: week,
          vat: vat,
          gm_solution: gm_solution
        }
      }).then(res => {
        if (Object.keys(res.data).length > 0) {
          axios.get(this.crmApiPath + 'sage/export/invoice/deductions', {
            params: {
              client_id: client_id,
              sage_ref: sage_ref,
              vat: vat,
              week: week,
              invoice_type: invoice_type,
              sites: sites,
              gm_solution: gm_solution
            }
          }).then(response => {
            let c_type = '';
            if (invoice_type === 'vat - sites one line - plus additions' || invoice_type === 'vat - sites per line - plus additions' ||
                invoice_type === 'vat - sites one line - extra additions' || invoice_type === 'vat - sites per line - extra additions') {
              c_type = 'credit note';
            }
            else if (invoice_type === 'vat - sites - plus additions' || invoice_type === 'sites') {
              c_type = 'sites credit note'
            }
            this.download_file(response.data, client_name, c_type, vat);
          });
        }
      })
    },

    download_file(file, client_name, invoice_type, vat) {
      let file_name = '';
      if (invoice_type === 'vat - sites one line - plus additions' || invoice_type === 'vat - sites per line - plus additions') {
        file_name = '_INVOICE_';
      }
      else if (invoice_type === 'vat - sites - plus additions' || invoice_type === 'vat - sites - extra additions') {
        file_name = '_INVOICE_SITES_';
      }
      else if (invoice_type === 'credit note') {
        file_name = '_CREDIT_DEDUCTIONS_';
      }
      else if (invoice_type === 'sites credit note') {
        file_name = '_SITES_CREDIT_DEDUCTIONS_';
      }
      else if (invoice_type === 'additions invoice') {
        file_name = '_ADDITIONS_INVOICE_';
      }
      let vat_text = '';
      if (vat === '20%') {
        vat_text = 'VAT_20-';
      }
      else if (vat === '5%') {
        vat_text = 'VAT_5-';
      }
      else if (vat === '0%') {
        vat_text = 'VAT_0-';
      }

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([file]));
      link.setAttribute('download', client_name + file_name + vat_text + this.$moment().utc().format('DD-MM-YYYY') + '.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    exportSageInvoice(client_id, week) {
      this.dsi = true;
      axios.get(this.crmApiPath + 'sage/export/invoice/vat', {params: {client_id: client_id}}).then(res => {
        let num_sites = res.data.number_sites;
        let vat = {
              vat_20: false,
              vat_5: false,
              vat_0: false,
            },
            vat_20_sites = {},
            vat_5_sites = {},
            vat_0_sites = {};

        if (this.client_ts_gm_solution === 'Standard Payroll') {
          vat.vat_20 = true;
          for (let i = 1; i <= num_sites; i++) {
            vat_20_sites[i] = res.data['site_' + i + '_name'].replace(/,/g, '');
          }
        }
        else if (this.client_ts_gm_solution === 'Project Managed Labour Solutions') {
          for (let i = 1; i <= num_sites; i++) {
            if (res.data['site_' + i + '_vat'] === '20%') {
              vat.vat_20 = true;
              vat_20_sites[i] = res.data['site_' + i + '_name'].replace(/,/g, '');
            }
            else if (res.data['site_' + i + '_vat'] === '5%') {
              vat.vat_5 = true;
              vat_5_sites[i] = res.data['site_' + i + '_name'].replace(/,/g, '');
            }
            else if (res.data['site_' + i + '_vat'] === '0%') {
              vat.vat_0 = true;
              vat_0_sites[i] = res.data['site_' + i + '_name'].replace(/,/g, '');
            }
          }
        }

        if (this.client_ts_invoice_type === 'vat - sites one line - plus additions' || this.client_ts_invoice_type === 'vat - sites per line - plus additions') {
          for (const key in vat) {
            if (key === 'vat_20' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '20%', vat_20_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_deductions_credit(client_id, week, '20%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_20_sites, this.clientname_ts, this.client_ts_gm_solution)
              });
            }
            if (key === 'vat_5' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '5%', vat_5_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_deductions_credit(client_id, week, '5%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_5_sites, this.clientname_ts, this.client_ts_gm_solution)
              });
            }
            if (key === 'vat_0' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '0%', vat_0_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_deductions_credit(client_id, week, '0%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_0_sites, this.clientname_ts, this.client_ts_gm_solution)
              });
            }
          }
          this.$nextTick(() => this.dsi = false);
        }
        else if (this.client_ts_invoice_type === 'vat - sites one line - extra additions' || this.client_ts_invoice_type === 'vat - sites per line - extra additions') {
          for (const key in vat) {
            if (key === 'vat_20' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '20%', vat_20_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_additions_invoice(client_id, week, '20%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_20_sites, this.clientname_ts, this.client_ts_gm_solution);
                this.export_deductions_credit(client_id, week, '20%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_20_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
            if (key === 'vat_5' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '5%', vat_5_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_additions_invoice(client_id, week, '5%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_5_sites, this.clientname_ts, this.client_ts_gm_solution);
                this.export_deductions_credit(client_id, week, '5%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_5_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
            if (key === 'vat_0' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '0%', vat_0_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_additions_invoice(client_id, week, '0%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_0_sites, this.clientname_ts, this.client_ts_gm_solution);
                this.export_deductions_credit(client_id, week, '0%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_0_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
          }
          this.$nextTick(() => this.dsi = false);
        }
        else if (this.client_ts_invoice_type === 'vat - sites - plus additions') {
          for (const key in vat) {
            if (key === 'vat_20' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '20%', vat_20_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_deductions_credit(client_id, week, '20%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_20_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
            if (key === 'vat_5' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '5%', vat_5_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_deductions_credit(client_id, week, '5%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_5_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
            if (key === 'vat_0' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '0%', vat_0_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_deductions_credit(client_id, week, '0%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_0_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
          }
          this.$nextTick(() => this.dsi = false);
        }
        else if (this.client_ts_invoice_type === 'vat - sites - extra additions') {
          for (const key in vat) {
            if (key === 'vat_20' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '20%', vat_20_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_additions_invoice(client_id, week, '20%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_20_sites, this.clientname_ts, this.client_ts_gm_solution);
                this.export_deductions_credit(client_id, week, '20%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_20_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
            if (key === 'vat_5' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '5%', vat_5_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_additions_invoice(client_id, week, '5%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_5_sites, this.clientname_ts, this.client_ts_gm_solution);
                this.export_deductions_credit(client_id, week, '5%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_5_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
            if (key === 'vat_0' && vat[key] === true) {
              this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '0%', vat_0_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
                this.export_additions_invoice(client_id, week, '0%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_0_sites, this.clientname_ts, this.client_ts_gm_solution);
                this.export_deductions_credit(client_id, week, '0%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_0_sites, this.clientname_ts, this.client_ts_gm_solution);
              });
            }
          }
          this.$nextTick(() => this.dsi = false);
        }
        else if (this.client_ts_invoice_type === 'sites') {
          for (let i = 1; i <= num_sites; i++) {
            axios.get(this.crmApiPath + 'sage/export/invoice/sites', {
              params: {
                client_id: client_id,
                invoice_type: this.client_ts_invoice_type,
                sage_ref: this.client_ts_sage_ref,
                site: i,
                week: week,
                gm_solution: this.client_ts_gm_solution
              }
            }).then(response => {
              if (response.data !== '') {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', this.clientname_ts + '_INVOICE_SITE_' + res.data['site_' + i + '_name'] + '-' + this.$moment().utc().format('DD-MM-YYYY') + '.csv');
                document.body.appendChild(link);
                link.click();
                link.remove();
              }
            })
          }

          for (const key in vat) {
            if (key === 'vat_20' && vat[key] === true) {
              // this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '20%', vat_20_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
              this.export_additions_invoice(client_id, week, '20%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_20_sites, this.clientname_ts, this.client_ts_gm_solution);
              this.export_deductions_credit(client_id, week, '20%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_20_sites, this.clientname_ts, this.client_ts_gm_solution);
              // });
            }
            if (key === 'vat_5' && vat[key] === true) {
              // this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '5%', vat_5_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
              this.export_additions_invoice(client_id, week, '5%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_5_sites, this.clientname_ts, this.client_ts_gm_solution);
              this.export_deductions_credit(client_id, week, '5%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_5_sites, this.clientname_ts, this.client_ts_gm_solution);
              // });
            }
            if (key === 'vat_0' && vat[key] === true) {
              // this.export_invoice(client_id, this.client_ts_invoice_type, this.client_ts_sage_ref, '0%', vat_0_sites, week, this.clientname_ts, this.client_ts_gm_solution).then(() => {
              this.export_additions_invoice(client_id, week, '0%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_0_sites, this.clientname_ts, this.client_ts_gm_solution);
              this.export_deductions_credit(client_id, week, '0%', this.client_ts_sage_ref, this.client_ts_invoice_type, vat_0_sites, this.clientname_ts, this.client_ts_gm_solution);
              // });
            }
          }

          this.$nextTick(() => this.dsi = false);
        }
      });
    },

    viewTimesheet(client_id, week) {
      this.det = true;
      axios.get(this.crmApiPath + 'sage/export/view_timesheets', {
        responseType: 'arraybuffer',
        params: {
          client_id: client_id,
          week: week
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'View_TS_-' + this.clientname_ts + '-' + this.$moment().utc().format('DD-MM-YYYY') + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.det = false;
      })
    },

    close() {
      this.client_ts = 0;
      this.client_ts_invoice_type = null;
      this.client_ts_sage_ref = null;
      this.client_ts_gm_solution = null;
      this.clientname_ts = "";
      this.client_id_ts = null;
      this.client_id_tsetups = null;
      this.client_expected_ts = null;
      this.client_completed_ts = null;
    },
  }
}
</script>
<style scoped lang="scss">
.homepageLinks {
  i {
    font-size:      1.35rem;
    display:        inline-block;
    margin-right:   15px;
    vertical-align: top;
  }

  h3 {
    display:        inline-block;
    vertical-align: top;
    margin-bottom:  0;
    font-size:      1.25rem;

    #name {
      display: block;
    }
  }
}
</style>
<style lang="scss">

.tsre {
  display: inline-block;

  .tsre_card {
    margin:     5px;
    height:     initial;
    border:     3px solid;
    padding:    0;
    text-align: right;

    &.complete {
      background:   $white;
      border-color: $green;

      .tsre_client {
        color: $green;
      }

      .tsre_ce {
        background: $green;
      }
    }

    &.not_complete {
      background:   $white;
      border-color: $red;

      .tsre_client {
        color: $red;
      }

      .tsre_ce {
        background: $red;
      }
    }

    .tsre_ce {
      display:        inline-block;
      text-align:     left;
      padding:        5px 10px;
      vertical-align: middle;
      color:          $white;
    }

    .tsre_client {
      text-align:     left;
      font-weight:    bold;
      max-width:      205px;
      display:        inline-block;
      padding:        5px;
      vertical-align: middle;
    }

    &:hover, &:focus, &:active:focus, &:active, &:target {
      &.complete {
        background:   $green;
        border-color: darken($green, 5%);

        .tsre_client {
          color: $white;
        }
      }

      &.not_complete {
        background:   $red;
        border-color: darken($red, 5%);

        .tsre_client {
          color: $white;
        }
      }
    }
  }
}

.bcard_ts_words {
  color:       $bc_1;
  font-weight: bold;
  font-size:   1.5rem;
}

.bcard_ts_content {
  color:       $bc_2;
  font-weight: bold;
  font-size:   1.5rem;
  float:       right;
}
</style>
